import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function ReviewEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border bg-card p-12 text-center">
      <CheckCircle2 className="mb-3 h-10 w-10 text-emerald-500" />
      <h3 className="text-base font-semibold">Nessun evento da revisionare</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">
        La coda MANUAL_REVIEW e' vuota. I nuovi eventi incerti compariranno qui
        non appena arrivano.
      </p>
      <Button asChild variant="outline" size="sm" className="mt-4">
        <Link to="/events">Vai agli eventi</Link>
      </Button>
    </div>
  );
}
